export default __webpack_public_path__ + "static/media/quickly-icon.20564f14.png";